import styled from "@emotion/styled";
import { IconButton, Box, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SlideModal } from "components/Modal/SlideModal";

const Container = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100%;
  color: #292929;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 68px;
  font-weight: 500;
`;

const Body = styled.div`
  display: flex;
  flex: 8;
  flex-direction: column;
  padding: 3%;
  height: 100%;
  overflow: scroll;
`;

const Title = styled.div`
  font-weight: bold;
`;

const Text = styled.div``;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
  text-align: center;

  th {
    font-weight: 500;
    border: 1px solid #ccc;
    padding: 5px;
  }

  td {
    border: 1px solid #ccc;
    padding: 5px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  button {
    width: 100%;
    height: 10vh;
    font-size: 3vw;
  }
`;

const iconButtonStyle = { width: "50px", height: "50px", margin: "5px 10px" };

export function TermsModal({ open, onClose }) {
  return (
    <SlideModal open={open}>
      <Container>
        <Header>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "3vw",
              width: "100%",
              height: "68px",
            }}
          >
            <Box sx={{ marginLeft: "70px" }}>전문보기</Box>
          </Box>
          <Box sx={{ marginLeft: "auto", height: "100%" }}>
            <IconButton
              sx={{
                ...iconButtonStyle,
                color: "#ADAEBC",
              }}
              onClick={() => onClose()}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Header>
        <Body>
          <Title>[필수] 개인정보 수집 및 활용 동의</Title>
          <br />
          <Text>
            본원은 귀하의 소중한 개인정보(및 민감정보)를 의료법 및
            개인정보보호법 등 관계 법령에 따라 진료 및 진료지원 등 아래의
            목적으로 수집·이용합니다.
          </Text>
          <br />
          <Title>1. 개인 정보의 수집 및 이용 목적</Title>
          <Text>- 진료/건강검진 예약, 조회 및 진료를 위한 본인확인절차</Text>
          <Text>- 병의원 업무와 의학정보 안내 등 서비스 이용 안내</Text>
          <Text>
            - 진단 및 치료를 위한 서비스(협의진료에 필요한 개인정보 및
            진료정보공유)
          </Text>
          <Text>- 진료비 청구, 수납, 환불 등의 원무 서비스</Text>
          <Text>
            - 진료비계산서, 내역서, 제증명서 발송 및 약품/건강검진 물품 및
            결과발송
          </Text>
          <Text>- 온라인/오프라인 검사 수탁, 외부검사 의뢰</Text>
          <Text>- 민원/고충 처리 등을 돕기 위한 의사소통의 경로 확보</Text>
          <Text>
            - 의료의 질관리, 의료기관 인증평가, 병원운영을 위한 법적, 행정적
            대응 및 조치
          </Text>
          <Text>- 교육, 연구에 필요한 최소한의 분석 자료</Text>
          <Text>- 가족 등에게 병의 증세, 환자상태 설명, 병실조회 및 면회</Text>
          <br />
          <Title>2. 개인정보 수집항목</Title>
          <Text>
            - 이름, 주민등록번호, 주소 등 의료법 제22조에 따라 의무기록에
            명시되는 항목
          </Text>
          <Text>- 전화번호, E-mail 등</Text>
          <Text>- 문진표 및 진료신청서 내 기재항목</Text>
          <br />
          <Title>3. 개인정보보유∙이용기간</Title>
          <Text>
            본원은 개인정보를 의료법 등 관계 법령에서 정한 보존기간 및 수집·이용
            목적 달성에 필요한 기간 동안 보관·이용하며, 보존기간 경과 또는 목적
            달성 시 지체 없이 파기합니다.
            <br />
            다만, 법령에 따라 보존이 필요한 경우에는 해당 기간 동안 보관하며,
            정보주체가 삭제를 요청하는 경우에도 법령상 보존 의무가 없는 범위
            내에서 지체 없이 파기합니다.
          </Text>
          <Text>
            - 의료법에 따라 환자명부(5년), 진료기록부(10년), 처방전(2년),
            수술/시술기록(10년), 검사소견서(5년), 방사선 사진 및 소견서(5년)
            등은 법정 보존기간 동안 보존합니다.
          </Text>
          <Text>
            - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의
            소비자 보호에 관한 법률)
          </Text>
          <Text>
            - 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년(신용정보의 이용
            및 보호에 관한 법률)
          </Text>
          <Text>
            - 본인 확인에 관한 기록: 6개월(정보통신망 이용촉진 및 정보보호 등에
            관한 법률)
          </Text>
          <br />
          <Title>4. 고유 식별정보의 수집∙이용</Title>
          <Text>
            상기 항목을 포함한 개인정보 수집 ∙ 이용을 위하여 아래와 같이 고유
            식별정보를 수집 ∙ 이용할 수 있습니다.
            <br />- 고유 식별정보 : 외국인등록번호, 여권번호, 운전면허번호
          </Text>
          <br />
          <Title>5. 민감정보(건강정보)의 수집∙이용</Title>
          <Text>
            상기 항목을 포함한 진료서비스를 위하여 아래와 같이 민감
            정보(건강정보)를 수집 ∙ 이용할 수 있습니다.
            <br />- 병력 및 가족력, 종교 등 의료진이 필요하다고 판단되는 개인
            건강정보 등
          </Text>
          <br />
          <Title>6. 영상정보처리기기(CCTV) 운영 안내 및 동의</Title>
          <Text>
            본원은 고객 안전 확보 및 분쟁 발생 시 객관적 자료 확보 등을 위해
            원내 CCTV를 촬영·저장할 수 있으며, 촬영 영상에는 시술 장면 등
            민감정보가 포함될 수 있습니다. CCTV 운영 및 영상의 보관·열람 등은
            관계 법령 및 내부 기준에 따라 관리됩니다.
          </Text>
          <br />
          <Title>7. 동의 거부 권리 및 불이익(제한사항)</Title>
          <Text>
            귀하는 동의를 거부할 권리가 있습니다. 다만, 필수 항목에 대한 동의를
            거부할 경우 접수/진료/원무처리 등 서비스 제공이 제한될 수 있습니다.
          </Text>
          <br />
          <Title>8. 개인정보의 제3자 제공</Title>
          <Text>
            본원은 의료법 제21조 및 기타 다른 법률에서 개인정보의 제공 규정이
            있는 경우 이외에 개인정보를 제공하는 경우에는 별도 동의를 받고
            있습니다.
          </Text>
          <br />
          <Title>9. 개인정보처리 위탁</Title>
          <Text>
            <Table>
              <thead>
                <th>업체명</th>
                <th>위탁 업무 내용</th>
                <th>보유기간</th>
              </thead>
              <tbody>
                <td>(주)케어랩스</td>
                <td>원내 고객관리 시스템 유지보수</td>
                <td>위탁계약 종료시까지</td>
              </tbody>
            </Table>
          </Text>
          <br />
          <Text>
            개인정보수집이용 제공 동의서 작성 후에도 의료법 및 개인정보보호법 등
            관계법령에 특히 규정 된 경우를 제외 하고는 동의자가 원하는 경우에는
            동의 여부를 언제든지 변경 또는 철회 할 수 있음을 알려 드립니다.
            <br />
            [개인정보 보호법]에 의거 위와 같이 개인정보 수집 및 이용에
            동의합니다.
          </Text>
          <ButtonWrapper>
            <Button
              variant="contained"
              sx={
                {
                  // width: "100%",
                  // height: "10vh",
                  // fontSize: "3vw",
                }
              }
              onClick={() => onClose(true)}
            >
              확인
            </Button>
          </ButtonWrapper>
        </Body>
      </Container>
    </SlideModal>
  );
}
